/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCollectionsProfile.ts            *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/collections-profile";

export class AutogenModelCollectionsProfile<RowType extends ModelRow> extends Endpoint<RowType, RowCollectionsProfileFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCollectionsProfile extends ModelRow<RowCollectionsProfileFields> {
	constructor(values?: Partial<RowCollectionsProfileFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCollectionsProfileFields {
	age_by_date: Date;
	collections_user_exclude: string;
	collections_user_ids: string;
	company_id: string;
	customer_exclude: string;
	customer_ids: string;
	cutoff_date: Date;
	descr: string;
	exclude_under_threshold: string;
	id: string;
	profile_color: string;
	show_collections_user_blank: string;
}

